import { type PopupTargetPageType } from '@hooks-api/types/dataModel/popup'
import { isPatternMatch } from './isPatternMatch'

interface IsRouteMatchPopupRulesProps {
  targetPageType: PopupTargetPageType
  includeTriggerPatterns: string[]
  excludeTriggerPatterns: string[]
}

export const isRouteMatchPopupRules = (props: IsRouteMatchPopupRulesProps) => {
  const { targetPageType, includeTriggerPatterns, excludeTriggerPatterns } = props
  /** 排除 wp、fp 特定路由 */
  const excludePatterns = ['/wp-admin', '/my-account', '/login', '/line-liff-login', '/line-liff-wheel', '/special-coupon']
  if (excludePatterns.some(pattern => window.location.href.includes(pattern))) {
    return false
  }
  /** 排除 popup 路由 */
  const isExcluded = excludeTriggerPatterns.some((pattern) => {
    const base = pattern.replace('/*', '')
    return window.location.href.startsWith(base)
  })
  if (isExcluded) {
    return false
  }
  else {
    // 全頁顯示
    if (targetPageType === 'all') {
      return true
    }

    // 指定頁面顯示
    if (targetPageType === 'specific') {
      return includeTriggerPatterns.some((pattern) => {
        return isPatternMatch({
          pattern,
          currentUrl: window.location.href,
        })
      })
    }
    return false
  }
}
